(function () {
  function init(root) {
    var openers = root.querySelectorAll('[data-ba-open]');
    var dialog = root.querySelector('[data-ba-dialog]');
    if (!dialog) return;
    var closers = dialog.querySelectorAll('[data-ba-close]');
    var form = dialog.querySelector('[data-ba-form]');

    function open() { dialog.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { dialog.hidden = true; document.body.style.overflow = ''; }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    dialog.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var success = form.getAttribute('data-success') || 'Appointment requested. We will contact you within 24 hours.';
        window.alert(success);
        form.reset();
        close();
      });
    }
  }

  document.querySelectorAll('[data-ba-root]').forEach(init);
})();
